import type { WorkflowStatus } from '@server/types';

import { Badge } from '@/_shared/components/ui/badge';

type BadgeVariant = React.ComponentProps<typeof Badge>['variant'];

const STATUS_VARIANT: Record<WorkflowStatus, BadgeVariant> = {
  active: 'success',
  paused: 'warning',
  draft: 'outline', // neutral — the badge palette has no plain grey variant
};

/** The active/paused/draft status pill, shared by the workflow card and the workflow list. */
export function WorkflowStatusBadge({ status }: { status: WorkflowStatus }): React.ReactElement {
  return (
    <Badge variant={STATUS_VARIANT[status] ?? 'outline'} bordered className="shrink-0 capitalize">
      {status}
    </Badge>
  );
}
